import React from 'react';
import { Text } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AutoLocationTransferZone(props) {
  const {
    value,
    object,
    isDetail,
    isVehicle
  } = props;
  const relocationName = isVehicle ? object?.data?.data?.locator?.data?.pendingRelocation?.location?.name : object?.data?.data?.pendingRelocation?.location?.name;
  const zone = Array.isArray(value) ? value[0] : value;
  let text;
  if (zone && zone !== '-') {
    text = relocationName ? `${zone} - ${relocationName}` : zone;
  } else {
    text = relocationName ? `Pending - ${relocationName}` : zone || '-';
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: isDetail ? 'detailValue' : 'columnValue',
    children: text
  });
}